import React from 'react';
import { LiaTemperatureLowSolid } from 'react-icons/lia';
import { MdOutlineWaterDrop } from 'react-icons/md';
import { ImPower } from "react-icons/im";
import { TbDroplets, TbSolarElectricity, TbWavesElectricity, TbChartBubble } from 'react-icons/tb';
import { SiWeightsandbiases } from "react-icons/si";
import { PiDropHalfBottomLight } from "react-icons/pi";
import { IoIosTrendingUp } from "react-icons/io";
import { CiLight } from "react-icons/ci";
import { PiGpsFixLight } from "react-icons/pi";
import { GiLevelEndFlag } from "react-icons/gi";
import { GrCloudDownload } from "react-icons/gr";

import './RenderIconMeasure.css'; // CSS separado para estilos responsivos

const RenderIconMeasure = (measure) => {
  const iconClass = "icon-measure"; // classe CSS comum para todos os ícones

  switch (measure) {
    case 'Temperatura':
      return <LiaTemperatureLowSolid className={iconClass} />;
    case 'Umidade':
      return <TbDroplets className={iconClass} />;
    case 'Corrente':
      return <ImPower className={iconClass} />;
    case 'Tensão':
      return <TbWavesElectricity className={iconClass} />;
    case 'Potência':
      return <TbSolarElectricity className={iconClass} />;
    case 'pH':
      return <MdOutlineWaterDrop className={iconClass} />;
    case 'OD':
      return <TbChartBubble className={iconClass} />;
    case 'TDS':
      return <SiWeightsandbiases className={iconClass} />;
    case 'Salinidade':
      return <PiDropHalfBottomLight className={iconClass} />;
    case 'Consumo':
      return <IoIosTrendingUp className={iconClass} />;
    case 'Luminosidade':
      return <CiLight className={iconClass} />;
    case 'Nível de Líquido':
      return <GiLevelEndFlag className={iconClass} />;
    case 'gps':
      return <PiGpsFixLight className={iconClass} />;
    case 'Pressão Atmosférica':
      return <GrCloudDownload className={iconClass} />
    default:
      return null;
  }
}

export default RenderIconMeasure;
